<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-if="buttonText != null">
          <v-btn
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              :loading="loading"
          >
            {{ buttonText }}
          </v-btn>
        </span>
        <span v-else>
          <v-icon
              v-bind="$attrs"
              v-on="on"
              dark
              :loading="loading"
          >
            {{ icon }}
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.qty" label="QTY" type="number"
                              outlined clearable clear-icon="mdi-close-circle"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.original_text" label="Origin text"
                            outlined clearable clear-icon="mdi-close-circle"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.mpn" label="MPN"
                              outlined clearable clear-icon="mdi-close-circle"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-checkbox v-model="editedItem.partial_match" label="Partial match"
                            outlined clearable clear-icon="mdi-close-circle"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.comment" label="Comment"
                            outlined clearable clear-icon="mdi-close-circle"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onClose">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

export default {
  name: 'MPNResearchDialog',
  inheritAttrs: false,
  props: ['loading', 'icon', 'buttonText', 'title', 'item', 'onSaveAction'],

  methods: {
    onClose() {
      this.dialog = false
    },
    onSave() {
      this.dialog = false
      if (this.buttonText !== null)
        this.editedItem.id = null
      this.onSaveAction(this.editedItem)
    },
  },

  mounted() {
  },

  data() {
    return {
      dialog: false,
      editedItem: JSON.parse(JSON.stringify(this.item)),
    }
  },
}

</script>


<style scoped lang="scss">
</style>